'use client';

import { c as _c } from "react/compiler-runtime";
import type { Condition } from '@repo/api-gw-sdk';
import { SelectionPanel } from '@/components/panels/selectionPanel/selectionPanel';
import { TextDetailsTuple } from '@/components/text/textDetailsTuple';

/** One picked value, tagged with the condition it came from. */
export interface SelectedConditionValue {
  property: string;
  value: string;
}

/**
 * The bottom selected-items drawer for a chip panel that owns several
 * conditions. `MultiSelectConditionPanel` gets the same drawer from
 * SelectionPanel for its single condition; a tree panel writes one condition
 * per level (a data class vs one of its entities, a severity vs one of its
 * controls), so the drawer spans them and remembers which property each value
 * came from in order to remove it again.
 */
export const ConditionSelectionPanel = t0 => {
  const $ = _c(18);
  const {
    conditions,
    onConditionsChange,
    entityName,
    labelOf,
    children
  } = t0;
  let t1;
  if ($[0] !== conditions) {
    t1 = conditions.flatMap(_temp);
    $[0] = conditions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  let t2;
  if ($[2] !== labelOf) {
    t2 = item_0 => <TextDetailsTuple primaryProp={labelOf(item_0)} />;
    $[2] = labelOf;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== conditions || $[5] !== onConditionsChange) {
    t3 = item_1 => onConditionsChange(conditions.map(condition_0 => condition_0.property === item_1.property ? {
      ...condition_0,
      value: (condition_0.value ?? []).filter(value_0 => value_0 !== item_1.value)
    } : condition_0).filter(_temp3));
    $[4] = conditions;
    $[5] = onConditionsChange;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onConditionsChange) {
    t4 = () => onConditionsChange([]);
    $[7] = onConditionsChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== entityName || $[10] !== items || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = {
      items,
      entityType: entityName,
      itemKey: _temp2,
      renderItem: t2,
      onRemove: t3,
      clearAll: t4
    };
    $[9] = entityName;
    $[10] = items;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== children || $[16] !== t5) {
    t6 = <SelectionPanel isLoading={false} drawerProps={t5}>{children}</SelectionPanel>;
    $[15] = children;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
function _temp(condition) {
  return (condition.value ?? []).map(value => ({
    property: condition.property ?? "",
    value
  }));
}
function _temp2(item) {
  return `${item.property}:${item.value}`;
}
function _temp3(condition_1) {
  return condition_1.value?.length;
}